import { render, staticRenderFns } from "./ProductFormCreate.vue?vue&type=template&id=a0a76e2e"
import script from "./ProductFormCreate.vue?vue&type=script&lang=js"
export * from "./ProductFormCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductFormCreate.vue?vue&type=style&index=0&id=a0a76e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports